import styled from "styled-components";
import { IAppBar } from "./AppBar.interface";
import { ssm } from "../../../AppTheme.styled";

const StyledAppBar = styled.div<IAppBar>`
  position: relative;
  z-index: 1400;
  height: 58px;
  display: flex;
  padding: 8px 16px;
  margin-bottom: 16px;
  align-items: center;
  box-shadow: ${({ theme, isMenuOpened }) =>
    isMenuOpened
      ? `20px -20px 0px 20px ${theme.palette.mainBackground}`
      : "0px 4px 6px -1px rgba(26, 32, 44, 0.1), 0px 2px 4px -1px rgba(26, 32, 44, 0.06)"};
  background-color: ${({ theme }) => theme.palette.mainBackground};

  .MuiGrid-item {
    display: flex;
  }

  ${ssm} {
    padding: 8px 32px;
    margin-bottom: 24px;
  }
`;

export default StyledAppBar;
